export const VIEWPORT_PADDING = 16

type ButtonRectLike = Pick<DOMRect, 'left'>

export const computeMenuLeft = ({
  buttonRect,
  menuWidth,
  viewportWidth,
  viewportPadding = VIEWPORT_PADDING,
}: {
  buttonRect: ButtonRectLike
  menuWidth: number
  viewportWidth: number
  viewportPadding?: number
}) => {
  const minLeft = viewportPadding
  const maxLeft = Math.max(minLeft, viewportWidth - viewportPadding - menuWidth)

  return Math.max(minLeft, Math.min(buttonRect.left, maxLeft))
}
